import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { EducationStatusRequest, EducationStatusResponse } from "./types/education"
import { WorkTypeRequest, WorkTypeResponse, OccupationRequest, OccupationResponse, GetCitiesResponse, GetTownsResponse, GetTownsRequest, GetDistrictsResponse, GetDistrictsRequest, GetBranchesResponse, GetBranchesRequest, GetVarlikKaynagiResponse, GetIslemHacimleriResponse, GetIslemSayisiResponse } from "./types/job"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { Apply5Request, Apply5Response } from "./types/apply5"
import { GetCountryListRequest, GetCountryListResponse } from "./types/country"
import { SetGuidResponse } from "./types/setGuid"
import { Apply6Request } from "./types/apply6"
import { DynamicDocumentsRequest, DynamicDocumentsResponse } from "./types/dynamicDocuments"
import { CreateDynamicDocumentsRequest } from "./types/createDynamicDocuments"
import { GetWorkPlaceNameByNameRequest, GetWorkPlaceNameByNameResponse } from "./types/getWorkPlaceNameByName"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const functionCode = "CRC0001"
const errorCounter = "3"
const lockHours = "24"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "CRC0001",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    setGuid: builder.mutation<SetGuidResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          guid: body,
          NextTransactionUrl: "Facebook/WebCreditCard/SetGuid1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCreditCard/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCreditCard/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          dogumGun: body.dogumGun,
          dogumAy: body.dogumAy,
          dogumYil: body.dogumYil,
          cepTel: body.cepTel,
          captcha: body.captcha,
          kvkk: body.kvkk,
          aylikNetGelir: body.aylikNetGelir,
          channel: body.channel,
          cid: body.cid,
          p: body.p,
          guid: body.guid,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          NextTransactionUrl: "Facebook/WebCreditCard/ResendOtp1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          otpId: body.otpId,
          sid: body.sid,
          tc9g: body.tc9g,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply3",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getSecondNationalyCountryList: builder.mutation<GetCountryListResponse, GetCountryListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/SecondNationalityCountryList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getEducationStatuses: builder.mutation<EducationStatusResponse, EducationStatusRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbEducationList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkTypes: builder.mutation<WorkTypeResponse, WorkTypeRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          education: body.education,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbWorkTypeList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getOccupations: builder.mutation<OccupationResponse, OccupationRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          education: body.education,
          workType: body.workType,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbOccupationList1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          yerlesikUlke: body.yerlesikUlke,
          yurtdisiBaglantisi: body.yurtdisiBaglantisi,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply4",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply5: builder.mutation<Apply5Response, Apply5Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          ogrenimDurumu: body.ogrenimDurumu,
          calismaSekli: body.calismaSekli,
          meslek: body.meslek,
          isyeriAdi: body.isyeriAdi,
          isyeriTelefonu: body.isyeriTelefonu,
          useExistingAddress: body.useExistingAddress,
          isOffice: body.isOffice,
          canResumeWithExistingInfo: body.canResumeWithExistingInfo,
          evAdresi: body.evAdresi,
          isAdresi: body.isAdresi,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply5",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply6: builder.mutation<BaseResponse, Apply6Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          subeKodu: body.subeKodu,
          cardType: body.cardType,
          isAutoLimitIncrease: body.isAutoLimitIncrease,
          isOnlineShopping: body.isOnlineShopping,
          isDigitalCard: body.isDigitalCard,
          isLksApproved: body.isLksApproved,
          currency: body.currency,
          isDigitalEkstre: body.isDigitalEkstre,
          paymentWeek: body.paymentWeek,
          eposta: body.eposta,
          isCddActive: body.isCddActive,
          varlikKaynagi: body.varlikKaynagi,
          islemHacmi: body.islemHacmi,
          islemSayisi: body.islemSayisi,
          isTroy: body.isTroy,
          isZeroLimitApproved: body.isZeroLimitApproved,
          NextTransactionUrl: "Facebook/WebCreditCard/Apply6",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getTowns: builder.mutation<GetTownsResponse, GetTownsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/DistrictsList1",
          ilKodu: body.ilKodu,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getDistricts: builder.mutation<GetDistrictsResponse, GetDistrictsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/DigitalProductLookupData/GetMahalleler1",
          ilId: body.ilId,
          ilceId: body.ilceId,
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getBranches: builder.mutation<GetBranchesResponse, GetBranchesRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          mbbNo: body.mbbNo,
          tckn: body.tckn,
          address: body.address,
          branchTypesByComma: body.branchTypesByComma,
          Language: body.Language,
          NextTransactionUrl: "Facebook/DigitalProductClosestBranch/GetClosestBranchesByType1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getVarlikKaynagi: builder.mutation<GetVarlikKaynagiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddVarlikKaynagiBireyselList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemHacimleri: builder.mutation<GetIslemHacimleriResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemHacmiList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getIslemSayisi: builder.mutation<GetIslemSayisiResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CddIslemSayisiBireyselList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getDynamicDocuments: builder.mutation<DynamicDocumentsResponse, DynamicDocumentsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          docType: body.docType,
          NextTransactionUrl: "Facebook/WebCreditCard/GetDynamicDocuments1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    createDynamicDocuments: builder.mutation<BaseResponse, CreateDynamicDocumentsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          cardType: body.cardType,
          NextTransactionUrl: "Facebook/WebCreditCard/CreateDynamicDocuments1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkPlaceNameByName: builder.mutation<GetWorkPlaceNameByNameResponse, GetWorkPlaceNameByNameRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          name: body.name,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/WorkPlaceName1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useSetGuidMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, useGetEducationStatusesMutation, useGetWorkTypesMutation, useGetOccupationsMutation, useApply4Mutation, useApply5Mutation, useApply6Mutation, useGetSecondNationalyCountryListMutation, useGetCitiesMutation, useGetTownsMutation, useGetDistrictsMutation, useGetBranchesMutation, useGetVarlikKaynagiMutation, useGetIslemHacimleriMutation, useGetIslemSayisiMutation, useGetDynamicDocumentsMutation, useCreateDynamicDocumentsMutation, useGetWorkPlaceNameByNameMutation } = api

export default api
